import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from "react-redux";
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import { addToCart } from "../../store/actions/action";
import Product from './product';
import api from "../../api";
import ProductTabs from './alltab';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.jpeg';


const ProductSinglePage = (props) => {
    const { slug } = useParams();
    const { addToCart } = props;
    const [product, setProduct] = useState({});

    const Allproduct = api();

    useEffect(() => {
        const filteredProduct = Allproduct.find(item => item.slug === slug);
        setProduct(filteredProduct || {});
    }, [slug, Allproduct]);

    return (
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header wpo-header-style-s9 menu-left'} Logo={Logo}
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-5 col-md-1 col-1'}
                col4={'col-lg-5 col-md-4 col-2'}
            />
            <PageTitle pageTitle={'Interior Designer, Expert Architect'} pagesub={'Shop Single'} />
            <section className="wpo-shop-single-section section-padding">
                <div className="container">
                    {product ? <Product
                        item={product}
                        addToCart={addToCart}
                    /> : null}
                    <ProductTabs />
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

const mapStateToProps = state => {
    return {
        products: state.data.products,
    }
};

export default connect(mapStateToProps, { addToCart })(ProductSinglePage);
